import { AvailableComponents } from "../Components";

import GlassForRoundedHero from '../Headers/GlassForRoundedHero'

import './styles.css'

export default function HeroRounded({ config }) {
    const isWide = window.innerWidth > 920

    const screenMode = isWide ? "wide" : "mobile";

    const Info = () => (
        <div className='hero-main-info'>
            {config.content.map((content, i) => {
                const Component = AvailableComponents[content.type];
                if (!Component) return null;
                return <Component key={"component-" + i} config={content.settings} />;
            })}
        </div>
    )

    return (
        <div className={"hero-container " + (config.mode || 'LIGHT')}>
            {
                !isWide && <GlassForRoundedHero config={config.header} />
            }

            <section className="hero-rounded">
                {
                    isWide && <GlassForRoundedHero config={config.header} />
                }

                {
                    config.background[screenMode].type === 'IMAGE'
                        ? <img className="hero-bg" src={config.background[screenMode].path} />
                        : <video
                            className="hero-bg"
                            autoPlay
                            muted
                            loop
                            playsInline
                            controls={false}
                            disablePictureInPicture
                            preload="auto"
                            tabIndex={-1}
                        >
                            <source src={config.background[screenMode].path} />
                        </video>

                }


                {isWide && <Info />}
            </section>

            {!isWide && <Info />}
        </div>
    )
}

